import IEqual from "@framework/iequal";

export default class ListTags{
    Selected:boolean;
    Disabled:boolean;
    Value:IEqual<Object>;
    constructor(value:IEqual<Object>, selected:boolean, disabled:boolean){
      this.Value = value;
      this.Selected = selected;
      this.Disabled = disabled;
    }
  }


// WEBPACK FOOTER //
// ./~/ui-tags/src/listtags.ts